import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "baron",
  "use": "baron-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"baron\">\n  <path d=\"M12.4545 3.9697L15 1.42424L15 15L1.42424 15L3.9697 12.4545L12.4545 12.4545L12.4545 3.9697Z\" fill=\"#727272\" />\n  <path d=\"M3.54545 12.0303L1 14.5758L0.999999 0.999999L14.5758 0.999996L12.0303 3.54545L3.54545 3.54545L3.54545 12.0303Z\" />\n  <path d=\"M10.3333 10.3333L5.66667 10.3333L5.66667 5.66667L10.3333 5.66667L10.3333 10.3333Z\" fill=\"#727272\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol